import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import PublicIcon from '@mui/icons-material/Public';
import { useBandView, ViewMode } from '../../contexts/BandViewContext';

const ArtistViewSwitcher: React.FC = () => {
  const { viewMode, setViewMode } = useBandView();

  const handleChange = (_: React.MouseEvent<HTMLElement>, value: ViewMode | null) => {
    if (value) setViewMode(value);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        mb: 3,
        p: 1.5,
        borderRadius: 2,
        bgcolor: 'action.hover',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
        Viewing as:
      </Typography>
      <ToggleButtonGroup
        value={viewMode}
        exclusive
        onChange={handleChange}
        size="small"
      >
        <ToggleButton value="artist" sx={{ gap: 0.75, px: 2 }}>
          <PersonIcon fontSize="small" />
          Programmer View
        </ToggleButton>
        <ToggleButton value="public" sx={{ gap: 0.75, px: 2 }}>
          <PublicIcon fontSize="small" />
          Public Preview
        </ToggleButton>
      </ToggleButtonGroup>
      <Typography variant="caption" color="text.secondary">
        {viewMode === 'artist'
          ? 'You can see your private details — contact info, fees, availability.'
          : 'This is what the public sees. Personal details are hidden.'}
      </Typography>
    </Box>
  );
};

export default ArtistViewSwitcher;
